export default __webpack_public_path__ + "static/media/sportarena84_eV.dd2f5aed.jpg";